import type { FieldPath, FieldValues, UseFormReturn } from 'react-hook-form';
import { useEffect, useRef } from 'react';

export type IUseFormAutoFocusProps<TFieldValues extends FieldValues> = {
  form: UseFormReturn<TFieldValues>;
  name: FieldPath<TFieldValues>;
  disabled?: boolean;
};

export const useFormAutoFocus = <TFieldValues extends FieldValues>(
  props: IUseFormAutoFocusProps<TFieldValues>,
): void => {
  const { form, name, disabled } = props;
  const isInitRef = useRef(false);

  useEffect(() => {
    if (!isInitRef.current) {
      form.setFocus(name);
      isInitRef.current = true;
    }
  }, [disabled, form, name]);

  useEffect(() => {
    if (disabled) {
      isInitRef.current = false;
    }
  });
};
